/**
 * The same app serves the product at / and the sample-data demo at /demo. Everything
 * that addresses the server or stores data on the device is keyed by this base, so the
 * two never share sessions, queued taps or settings.
 */
const path = typeof location === 'undefined' ? '/' : location.pathname;
export const BASE = path === '/demo' || path.startsWith('/demo/') ? '/demo' : '';
export const IS_DEMO_PATH = BASE === '/demo';
